"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaleListing$ = exports.SaleListing$outboundSchema = exports.SaleListing$inboundSchema = void 0;
exports.saleListingToJSON = saleListingToJSON;
exports.saleListingFromJSON = saleListingFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const addresses_js_1 = require("./addresses.js");
const agentattributes_js_1 = require("./agentattributes.js");
const geopointlocation_js_1 = require("./geopointlocation.js");
const listingtype_js_1 = require("./listingtype.js");
const propertytypeobject_js_1 = require("./propertytypeobject.js");
/** @internal */
exports.SaleListing$inboundSchema = z.object({
    address: z.nullable(addresses_js_1.Addresses$inboundSchema),
    agent: agentattributes_js_1.AgentAttributes$inboundSchema,
    description: z.nullable(z.string()),
    distance_in_metres: z.nullable(z.number().int()),
    has_reduction: z.boolean(),
    images: z.array(z.string()),
    internal_area_square_metres: z.nullable(z.number().int()),
    is_available: z.nullable(z.boolean()),
    is_removed: z.nullable(z.boolean()),
    listed_date: z.string(),
    listing_id: z.string(),
    listing_type: z.nullable(listingtype_js_1.ListingType$inboundSchema),
    location: geopointlocation_js_1.GeoPointLocation$inboundSchema,
    main_image_url: z.nullable(z.string()),
    number_of_bathrooms: z.nullable(z.number().int()),
    number_of_bedrooms: z.nullable(z.number().int()),
    price: z.number().int(),
    price_per_square_metre: z.nullable(z.number().int()),
    property_type: z.nullable(propertytypeobject_js_1.PropertyTypeObject$inboundSchema),
    source: z.string(),
    status: z.string(),
    street_group_property_id: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "distance_in_metres": "distanceInMetres",
        "has_reduction": "hasReduction",
        "internal_area_square_metres": "internalAreaSquareMetres",
        "is_available": "isAvailable",
        "is_removed": "isRemoved",
        "listed_date": "listedDate",
        "listing_id": "listingId",
        "listing_type": "listingType",
        "main_image_url": "mainImageUrl",
        "number_of_bathrooms": "numberOfBathrooms",
        "number_of_bedrooms": "numberOfBedrooms",
        "price_per_square_metre": "pricePerSquareMetre",
        "property_type": "propertyType",
        "street_group_property_id": "streetGroupPropertyId",
    });
});
/** @internal */
exports.SaleListing$outboundSchema = z.object({
    address: z.nullable(addresses_js_1.Addresses$outboundSchema),
    agent: agentattributes_js_1.AgentAttributes$outboundSchema,
    description: z.nullable(z.string()),
    distanceInMetres: z.nullable(z.number().int()),
    hasReduction: z.boolean(),
    images: z.array(z.string()),
    internalAreaSquareMetres: z.nullable(z.number().int()),
    isAvailable: z.nullable(z.boolean()),
    isRemoved: z.nullable(z.boolean()),
    listedDate: z.string(),
    listingId: z.string(),
    listingType: z.nullable(listingtype_js_1.ListingType$outboundSchema),
    location: geopointlocation_js_1.GeoPointLocation$outboundSchema,
    mainImageUrl: z.nullable(z.string()),
    numberOfBathrooms: z.nullable(z.number().int()),
    numberOfBedrooms: z.nullable(z.number().int()),
    price: z.number().int(),
    pricePerSquareMetre: z.nullable(z.number().int()),
    propertyType: z.nullable(propertytypeobject_js_1.PropertyTypeObject$outboundSchema),
    source: z.string(),
    status: z.string(),
    streetGroupPropertyId: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        distanceInMetres: "distance_in_metres",
        hasReduction: "has_reduction",
        internalAreaSquareMetres: "internal_area_square_metres",
        isAvailable: "is_available",
        isRemoved: "is_removed",
        listedDate: "listed_date",
        listingId: "listing_id",
        listingType: "listing_type",
        mainImageUrl: "main_image_url",
        numberOfBathrooms: "number_of_bathrooms",
        numberOfBedrooms: "number_of_bedrooms",
        pricePerSquareMetre: "price_per_square_metre",
        propertyType: "property_type",
        streetGroupPropertyId: "street_group_property_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var SaleListing$;
(function (SaleListing$) {
    /** @deprecated use `SaleListing$inboundSchema` instead. */
    SaleListing$.inboundSchema = exports.SaleListing$inboundSchema;
    /** @deprecated use `SaleListing$outboundSchema` instead. */
    SaleListing$.outboundSchema = exports.SaleListing$outboundSchema;
})(SaleListing$ || (exports.SaleListing$ = SaleListing$ = {}));
function saleListingToJSON(saleListing) {
    return JSON.stringify(exports.SaleListing$outboundSchema.parse(saleListing));
}
function saleListingFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.SaleListing$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'SaleListing' from JSON`);
}
//# sourceMappingURL=salelisting.js.map